export default __webpack_public_path__ + "static/fireplaces-bf86e4bc67a8d412b024e8b38c3c919c.webp";